var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("A:/dev/workspace-node/bitbucket_repository/projects/widget-schedules-school-v3/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/services/utils/table.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "\r\n<style>\r\n.log {\r\n  font-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  text-align: center\r\n}\r\n\r\n.log td, .log th {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n}\r\n\r\n.log tr:nth-child(even){background-color: #f2f2f2;}\r\n\r\n.log tr:hover {background-color: #ddd;}\r\n\r\n.log th {\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n  background-color: #4CAF50;\r\n  color: white;\r\n}\r\n</style>\r\n\r\n\r\n<table class=\"log\">  ";
output += "\r\n    ";
if(runtime.contextOrFrameLookup(context, frame, "header")) {
output += "\r\n    <theader>\r\n        <tr>\r\n            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "header");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n                <th> ";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += " </th>\r\n            ";
;
}
}
frame = frame.pop();
output += "\r\n        </tr>\r\n    </theader>\r\n    ";
;
}
output += "\r\n    <tbody>\r\n        ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "rows");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("row", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\r\n        <tr>\r\n            ";
frame = frame.push();
var t_11 = t_8;
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("cell", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\r\n                <td>";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "</td>\r\n            ";
;
}
}
frame = frame.pop();
output += "\r\n        </tr>\r\n        ";
;
}
}
frame = frame.pop();
output += "\r\n    </tbody>\r\n</table>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/services/utils/table.njk"] , dependencies)